import React from 'react';

export default function FacilityCodeModalContent() {
  return <p>Unique identifier for VA-approved facilities.</p>;
}
